import React from "react";

/*
One labelled cell inside a FieldBlock.
- accent: light background, used for the net/total cell of a row
- strong: bold value
- wide: takes twice the width of a normal cell
*/
export function Field({label, value, accent = false, strong = false, wide = false}) {
    return (
        <div className={`ds-field ${accent ? 'ds-field-accent' : ''} ${strong ? 'ds-field-strong' : ''} ${wide ? 'ds-field-wide' : ''}`}>
            <div className="ds-field-label">{label}</div>
            <div className="ds-field-value">{value !== null && value !== undefined && value !== '' ? value : '-'}</div>
        </div>
    );
}

/*
Rounded block that lays out Field children in a single wrapping row, with
the cells sharing their dividing lines.
- title: renders a static leading cell with the block's name (used by the rows
  that are not collapsible, e.g. Kontering)
*/
export function FieldBlock({children, title = null}) {
    return (
        <div className={`ds-block ${title ? 'ds-block-titled' : ''}`}>
            {title ?
                <div className="ds-field-title">{title}</div>
            : ''}
            {children}
        </div>
    );
}
